import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';
import { GameProvider } from './context/GameContext';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.warn("Missing Publishable Key");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider 
      publishableKey={PUBLISHABLE_KEY} 
      afterSignOutUrl="/"
      appearance={{
        layout: {
          shimmer: true,
        },
        variables: {
          colorPrimary: '#00e2ca',
          colorText: 'white',
          colorTextSecondary: '#94a3b8',
          colorBackground: '#020617',
          colorInputBackground: '#1e293b',
          colorInputText: 'white',
          borderRadius: '0.5rem',
        },
        elements: {
          card: "bg-[#0a0f1d] border border-slate-800 shadow-2xl",
          headerTitle: "text-white",
          headerSubtitle: "text-slate-400",
          socialButtonsBlockButton: "bg-slate-800 border-slate-700 text-white hover:bg-slate-700",
          socialButtonsBlockButtonText: "text-white",
          dividerLine: "bg-slate-700",
          dividerText: "text-slate-400",
          formFieldLabel: "text-slate-300",
          formFieldInput: "bg-slate-900 border-slate-700 text-white",
          footerActionText: "text-slate-400",
          footerActionLink: "text-cyan-400 hover:text-cyan-300",

          // User Button Popover specific
          userButtonPopoverCard: "bg-[#0a0f1d] border border-slate-800 text-white shadow-xl",
          userPreviewMainIdentifier: "text-white font-bold",
          userPreviewSecondaryIdentifier: "text-slate-400",
          userButtonPopoverActionButton: "text-slate-300 hover:bg-slate-800 hover:text-white",
          userButtonPopoverActionButtonIcon: "text-slate-400",
          userButtonPopoverFooter: "bg-[#0a0f1d] border-t border-slate-800"
        }
      }}
    >
      <GameProvider>
        <App />
      </GameProvider>
    </ClerkProvider>
  </React.StrictMode>
);